import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/phoneAuth/admin/akedlyInboxQueryKeys.ts
var t = e("admin-akedly-inbox", {
	list: (e) => e === void 0 ? ["list"] : ["list", e],
	delivery: (e) => ["delivery", e],
	stats: () => ["stats"]
});
//#endregion
export { t as akedlyInboxQueryKeys };
